module.exports = __webpack_public_path__ + "img/center.dd30bf9f.svg";